/**
 *  Date    : 2019/2/21
 *  Author  : Zhang Guimei
 *  Declare : ServiceShareConfig
 */

import Utils from '@/utils/utils';

import ShareConfig from './WxShareConfig';

export default class ServiceShareConfig extends ShareConfig {
  getCommonShareQuery(props) {
    const { serviceInfo } = this.props;
    if(Utils.isNotEmpty(serviceInfo) && (serviceInfo.productId || serviceInfo.appId)) {
      const superShareQuery = super.getCommonShareQuery();
      return Object.assign({}, superShareQuery, {
        ref_svc_code: serviceInfo.productTypeCode || serviceInfo.typeCode,      //作品、应用类型
        ref_svc_id: serviceInfo.productId || serviceInfo.appId,                 //作品、应用Id
        ref_svc_type: serviceInfo.appId ? 0 : 1                                 //作品：0， 应用：1
      });
    } else {
      super.getCommonShareQuery();
    }
  }

  componentDidUpdate(prevProps) {
    if(this.unmounted) return;
    super.componentDidUpdate(prevProps);
    const { serviceInfo } = this.props, { serviceInfo: prevServiceInfo } = prevProps;
    if(prevServiceInfo.productId !== serviceInfo.productId || prevServiceInfo.appId !== serviceInfo.appId) {
      this.setShareConfig();
    }
  }
}